import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const state = {
  groups: [],
  uiFlags: {
    isFetching: false,
    isSaving: false,
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
